import React, { Component } from 'react';

import { connect } from 'react-redux'
import { teachersActions } from '../actions';
import { Spinner } from 'components/Icons/Spinner';

import { CourseSubjectHeader } from '../components/CourseSubjectHeader';
import { StudentSubjectEvalCard } from '../components/StudentSubjectEvalCard';
import { CalifTableCell } from '../components/CalifTableCell';

import { Row, Col, Card, CardBody, Modal, ModalBody } from "reactstrap";

var Utils = require ('Utils');
var viewActions = require ('store/view.actions');


class CourseSubjectCalif extends Component {

    constructor(props) {
      super(props);
      this.state = {
        modalOpen: false,
        commentsOnly: false,
        commentsReadOnly: false,
        currentCalif: {}
       };
    }

    openCommentModal(calif, col, student, evaluationID, readOnly = false) {
        this.setState({
            currentCalif: { calif: calif, col: col, student: student, evaluationID: evaluationID },
            commentsOnly: true,
            commentsReadOnly: readOnly,
            modalOpen: true,
        });
    }

    setModalOpen(st) {
        this.setState({ modalOpen: st, commentsOnly: st ? this.state.commentsOnly : false, commentsReadOnly: st ? this.state.commentsReadOnly : false });
    }

    getRows() {
        
        return this.props.courseStudents.map( (student) => {
 
          
          let filtra = this.props.allEvals.filter( c => c.persona_id === student.persona_id) ;
 
          let obj = filtra.map( (i) => {
                // i.studentName =  Utils.capitalize( student.last_name + ", " + student.name );
                return {...i, name : Utils.capitalize( student.last_name + ", " + student.name ) };
          })

          obj.push( {studentName: Utils.capitalize( student.last_name + ", " + student.name ), 
                        evaluation_id: 'studentName', persona_id : student.persona_id } );
           return obj; 
        })

      }

    getColumns ( ) {
        // Loop por las evaluaciones disponibles para este curso/materia
       
        let columns = [] ;
        this.props.courseEvals.evaluations.map( ev => {
            columns.push(
                          { 
                              width: "150" , 
                              title: ev.short_name, 
                              alt: ev.name,
                              field: ev.evaluation_id,
                              blocked: ev.blocked,
                              ev: ev
                          } 
            );
            return null;
        } );
        columns.unshift({ width: '300', title: 'Alumno', field: 'studentName' });
        return columns ;
      }


    componentDidMount() {

        this.props.getCourseSubject (this.props.token,  this.props.match.params.course_subject_id) ;
        this.props.getCourseSubjectStudents (this.props.token,  this.props.match.params.course_subject_id) ;
        this.props.getCourseEvals (this.props.token,  this.props.match.params.course_subject_id) ;
        this.props.getAllEvals (this.props.token,  this.props.match.params.course_subject_id) ;

        this.props.setMainTitle("Carga de calificaciones", [] )

        this.props.setBreadCrumb(
                    [{title:'Mis Cursos', link:'/admin/my-courses'},
                     {title: 'Datos del curso', link:'/admin/my-courses/'+this.props.match.params.course_subject_id}
                    ], 'Carga de calificaciones')
    }

    renderCell(col, row, persona) {
        let v = row.find(f => f.evaluation_id === col.field);

        if (col.field === 'studentName') {
            return <td>{v && v.studentName}</td>;
        }

        return (
            <CalifTableCell
                key={col.field + '-' + persona.persona_id}
                col={col}
                evalData={v}
                persona={persona}
                courseEvals={this.props.courseEvals}
                courseSubjectID={this.props.match.params.course_subject_id}
                token={this.props.token}
                createEval={this.props.addCourseSubjectStudentsEvals}
                updateEvals={this.props.updateCourseSubjectStudentsEvals}
                onOpenComments={(readOnly) => this.openCommentModal(v, col, persona, col.field, readOnly)}
            />
        );
    }

    render() {

        return ( 
            <>
            <Modal toggle={() => this.setModalOpen(!this.state.modalOpen)} isOpen={this.state.modalOpen}  size="lg">
                <ModalBody >
                    <StudentSubjectEvalCard 
                        data={this.state.currentCalif}
                        courseEvals={this.props.courseEvals}
                        updateEvals={this.props.updateCourseSubjectStudentsEvals}
                        createEval={this.props.addCourseSubjectStudentsEvals}
                        delEval={this.props.deleteCourseSubjectStudentsEvals}
                        token={this.props.token}
                        closeMe={this.setModalOpen.bind(this)}
                        commentsOnly={this.state.commentsOnly}
                        commentsReadOnly={this.state.commentsReadOnly}
                        /> 

                </ModalBody>
            </Modal>
            
            <div className="content">
            {this.props.courseSubject && this.props.courseEvals.evaluations  && this.props.allEvals
                && this.props.courseStudents && !this.props.view.loadingModules.getCourseSubject ?
               <Card>
                    <CourseSubjectHeader 
                        courseSubject={this.props.courseSubject}
                        
                        />

                    <CardBody>
                        <Row>
                            <Col sm="12">
                                <table>
                                    <tbody>
                                        <tr>
                                         { this.getColumns().map((col,idx) => {
                                            return(
                                                <>
                                                <td width={col.width} align="center" key={col.field}><b>{col.title}</b></td> 
                                                </> 
                                            )
                                        }) }
                                        
                                        </tr>
                                       
                                        {  this.getRows().map((row,idx) => {
                                            let persona = (row.find( (r) => r.evaluation_id === 'studentName'));
                                            return(
                                                <>
                                                <tr bgcolor={idx%2===0?"#f0f0f0":""} >
                                                    { this.getColumns().map((col) => {
                                                        
                                                        return( this.renderCell( col, row, persona) );
                                                    }) }
                                                </tr>
                                                </>
                                            )

                                            })}

                                            
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    </CardBody>

                </Card> 
            :
            <Spinner size="XL" />
          }

            </div>
        
        
        
        
        
        
        </>
        
            );
    }

}

const mapStateToProps = state => {
    return {
        token: state.auth.session.jwt_token,
        currentCalendarID: state.school.currentCalendarID,
        view: state.view,
        user: state.auth.session.user,
        courseSubject: state.teachers.courseSubject,
        courseEvals: state.teachers.courseEvals,
        courseStudents: state.teachers.courseStudents,
        allEvals: state.teachers.allEvals

    }
}

    
const mapDispatchToProps = dispatch => {
    return { 
        
        getCourseSubject: (token, courseSubjectID) => {
            dispatch(teachersActions.getCourseSubject(token, courseSubjectID));
        } , 
        setMainTitle: ( title, menu ) => {
          dispatch(viewActions.setMainTitle( title, menu ))
        },
        setBreadCrumb: ( breadCrumb, activeTitle ) => {
            dispatch(viewActions.setBreadCrumb( breadCrumb, activeTitle ))
          },
  
        getCourseEvals: (token, courseSubjectID) => {
            dispatch(teachersActions.getCourseEvals(token, courseSubjectID));
        } , 
        getAllEvals: (token, courseSubjectID) => {
            dispatch(teachersActions.getAllEvals(token, courseSubjectID));
        } , 
       
        getCourseSubjectStudents: (token, courseSubjectID ) => {
          dispatch(teachersActions.getCourseSubjectStudents(token, courseSubjectID));
        },
        updateCourseSubjectStudentsEvals: ( token, courseSubjectID, personaID, evaluationID, data, qualifValue ) => { 
            dispatch( teachersActions.updateCourseSubjectStudentsEvals ( token, courseSubjectID, personaID, evaluationID, data, qualifValue ) )
        },
        addCourseSubjectStudentsEvals: ( token, courseSubjectID, personaID, evaluationID, qualifValue ,qualifValueNbr,  comments ) => {
            dispatch( teachersActions.addCourseSubjectStudentsEvals ( token, courseSubjectID, personaID, evaluationID, qualifValue,qualifValueNbr , comments ))
        },
        deleteCourseSubjectStudentsEvals: ( token, courseSubjectID, personaID, evaluationID ) => { 
            dispatch( teachersActions.deleteCourseSubjectStudentsEvals ( token, courseSubjectID, personaID, evaluationID ) )
        }


    }
}

    export default connect(mapStateToProps, mapDispatchToProps)(CourseSubjectCalif);